import React from "react";
import { RendererProps } from "./index";
import { ChoiceList, ChoiceOption } from "./renderer-styles";

const ChoiceRenderer: React.FC<RendererProps> = ({
  question,
  answer,
  onAnswer,
}) => {
  const selectedKey = answer?.values?.[0] as string | undefined;

  return (
    <ChoiceList>
      {(question.choices || []).map((choice) => {
        const choiceKey = choice.name ?? String(choice.value);
        const isSelected = selectedKey
          ? selectedKey === choiceKey
          : answer?.value === choice.value;

        return (
          <ChoiceOption key={choiceKey} selected={isSelected}>
            <input
              type="radio"
              name={question.name}
              value={String(choice.value)}
              checked={isSelected}
              onChange={() => onAnswer(choice.value, true, [choiceKey])}
            />
            {choice.title || choice.label}
          </ChoiceOption>
        );
      })}
    </ChoiceList>
  );
};

export default ChoiceRenderer;
